export default "/images/1571803a8d6550aaa1915bd3b981e605.avif";